import type { Tokens } from '@/modules/common/adapters/tokens.type.ts';
import type { TokensDto } from '@/modules/common/dto/tokens.dto.ts';

export class TokensAdapter {
  static map(response: TokensDto): Tokens {
    return {
      accessToken: response.token,
      refreshToken: response.refresh_token,
    };
  }
}
